<template>
  <div class="absolute inset-0 flex flex-col items-center justify-center p-4">
    <AnimationUploading class="h-96 max-w-full"/>
    <p class="animate-pulse text-3xl font-bold text-slate-900">Uploading Resume...</p>
    <p class="mt-1 animate-pulse font-medium text-slate-600 mb-40 sm:mb-24">Hang tight, this may take a second.</p>
  </div>
</template>

<script setup>
import AnimationUploading from "./AnimationUploading.vue";
import {onBeforeUnmount, onMounted} from "vue";

onMounted(() => window.progressBar.start());
onBeforeUnmount(() => window.progressBar.complete());
</script>
